
import axios from 'axios';

const api = axios.create({
    baseURL: "https://d-road.dromii.com",
    headers: { 
        'Content-Type': 'application/json',
        'API-Key':'Zawpqp2wd0kq9cmxzm'
 },
  });

// AI - Detect 시작
export const detectstart = async (group_id, project_id, file_id, phone_number, company) => {
  try {
    const res = await api.post(
      `/ai/api/detect/${group_id}/${project_id}/${file_id}`,
      {}, // POST body
      { params: { phone_number, company } } // ✅ 쿼리 파라미터
    );

    return res;
  } catch (err) {
    console.error("⚠️ Detect API 호출 실패:", err);
    throw err;
  }
};

// AI - 탐지결과 ())
export const detectresult = async (groupId, projectId, fileId, model_type) => {

  try {
    const res = await api.get(
      `/ai/api/detections/summary/${groupId}/${projectId}/${fileId}/${model_type}`,
      {}
    );

    return res; // 응답 그대로 리턴
  } catch (err) {
    console.error("⚠️ Detect Result API 호출 실패:", err);
    throw err;
  }
};

// AI - 전체 탐지결과 (전체))
export const detectallresult = async (groupId, projectId, fileId) => {

  try {
    const res = await api.get(
      `/ai/api/detections/summary/${groupId}/${projectId}/${fileId}/all-model`,
      {}
    );

    return res; // 응답 그대로 리턴
  } catch (err) {
    console.error("⚠️ Detect Result API 호출 실패:", err);
    throw err;
  }
};

//AI - 진행도 확인 (progress)
export const detectprogress = async (groupId, projectId, fileId) => {

  try {
    const res = await api.get(
      `/ai/api/progress`,
      {}
    );

    return res; // 응답 그대로 리턴
  } catch (err) {
    console.error("⚠️ Detect progress API 호출 실패:", err);
    throw err;
  }
};


// AI - ortho 다운 
export const detectdownload = async (groupId, projectId, fileId) => {

  try {
    const res = await api.get(
      `/ai/api/tif-download/${groupId}/${projectId}/${fileId}/road_cropped.tif	`,
      {}
    );

    return res; // 응답 그대로 리턴
  } catch (err) {
    console.error("⚠️ Detect Down API 호출 실패:", err);
    throw err;
  }
};

